export default "__VITE_ASSET__CHypT3bc__"